import { FC, PropsWithChildren } from 'react';

const Development: FC<PropsWithChildren> = ({ children }) => {
    const isDev = import.meta.env.DEV;
    return isDev ? <>{children}</> : null;
};

export default Development;